module.exports = __webpack_public_path__ + "img/ic_activity_rm.a0fc2193.svg";